import { create } from "zustand";
import { AgentState, AgentActions } from "./types";

export const useAgentStore = create<AgentState & AgentActions>((set) => ({
	fullName: "",
	availability: "",
	activity: "",
	job: "",
	profilePhoto: "",
	statusTimer: "",
	setName: (name: string) => set(() => ({ fullName: name })),
	setStatusTimer: (statusTimer?: string | null) => set(() => ({ statusTimer: statusTimer ?? "" })),
	setPresence: (availability: string, activity?: string) =>
		set(() => ({ availability: availability, activity: activity })),
	setProfilePhoto: (profilePhoto: string) =>
		set(() => ({ profilePhoto: profilePhoto })),
	setJob: (jobTitle?: string, department?: string) => {
		if (jobTitle) {
			let job = jobTitle;

			if (department) {
				job = job.concat(`/${department}`);
			}
			set(() => ({ job: job }));
		} else {
			set(() => ({ job: department }));
		}
	}
}));
